import { render, staticRenderFns } from "./Statistics.vue?vue&type=template&id=186018f0&scoped=true"
var script = {}
import style0 from "./Statistics.vue?vue&type=style&index=0&id=186018f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "186018f0",
  null
  
)

export default component.exports